const LIMITS_FEATURE_KEY = "limits";
var LimitDataNames = /* @__PURE__ */ ((LimitDataNames2) => {
  LimitDataNames2["limitAmount"] = "limitAmount";
  LimitDataNames2["period"] = "period";
  LimitDataNames2["periodType"] = "periodType";
  LimitDataNames2["currencyId"] = "currencyId";
  LimitDataNames2["residualAmount"] = "residualAmount";
  LimitDataNames2["amount"] = "amount";
  return LimitDataNames2;
})(LimitDataNames || {});
var SelfExclusionType = /* @__PURE__ */ ((SelfExclusionType2) => {
  SelfExclusionType2[SelfExclusionType2["coolingOff"] = 2] = "coolingOff";
  SelfExclusionType2[SelfExclusionType2["selfExclusion"] = 3] = "selfExclusion";
  return SelfExclusionType2;
})(SelfExclusionType || {});
var LimitModalType = /* @__PURE__ */ ((LimitModalType2) => {
  LimitModalType2["info"] = "info";
  LimitModalType2["session"] = "session";
  LimitModalType2["balance"] = "balance";
  return LimitModalType2;
})(LimitModalType || {});
var PeriodType = /* @__PURE__ */ ((PeriodType2) => {
  PeriodType2[PeriodType2["seconds"] = 0] = "seconds";
  PeriodType2[PeriodType2["minutes"] = 1] = "minutes";
  PeriodType2[PeriodType2["hours"] = 2] = "hours";
  PeriodType2[PeriodType2["days"] = 3] = "days";
  PeriodType2[PeriodType2["weeks"] = 4] = "weeks";
  PeriodType2[PeriodType2["months"] = 5] = "months";
  PeriodType2[PeriodType2["years"] = 6] = "years";
  PeriodType2[PeriodType2["infinite"] = 10] = "infinite";
  return PeriodType2;
})(PeriodType || {});
var LimitTypes = /* @__PURE__ */ ((LimitTypes2) => {
  LimitTypes2[LimitTypes2["loss"] = 1] = "loss";
  LimitTypes2[LimitTypes2["deposit"] = 2] = "deposit";
  LimitTypes2[LimitTypes2["session"] = 3] = "session";
  LimitTypes2[LimitTypes2["balance"] = 4] = "balance";
  LimitTypes2[LimitTypes2["singleBet"] = 5] = "singleBet";
  LimitTypes2[LimitTypes2["wagerPerPeriod"] = 6] = "wagerPerPeriod";
  LimitTypes2[LimitTypes2["timeout"] = 7] = "timeout";
  LimitTypes2[LimitTypes2["balanceResidual"] = 8] = "balanceResidual";
  return LimitTypes2;
})(LimitTypes || {});
var LimitStatus = /* @__PURE__ */ ((LimitStatus2) => {
  LimitStatus2[LimitStatus2["disabled"] = 0] = "disabled";
  LimitStatus2[LimitStatus2["active"] = 1] = "active";
  LimitStatus2[LimitStatus2["confirmed"] = 2] = "confirmed";
  LimitStatus2[LimitStatus2["confirmedDisable"] = 3] = "confirmedDisable";
  LimitStatus2[LimitStatus2["unconfirmedDisable"] = 4] = "unconfirmedDisable";
  LimitStatus2[LimitStatus2["unconfirmed"] = 5] = "unconfirmed";
  return LimitStatus2;
})(LimitStatus || {});
export {
  LIMITS_FEATURE_KEY,
  LimitDataNames,
  LimitModalType,
  LimitStatus,
  LimitTypes,
  PeriodType,
  SelfExclusionType
};
